import raf from 'raf';
import { batch } from 'react-redux';

let rafID;
let notifyFunc;
function animFrame() {
  if (notifyFunc) {
    batch(notifyFunc);
    notifyFunc = null;
  }
  rafID = raf(animFrame);
}
export default function rafUpdateBatcher(notify) {
  if (rafID === undefined) rafID = raf(animFrame);
  notifyFunc = notify;
}
